export const accountListColumns = [
  {
    title: "工号",
    dataIndex: "workNo",
    width: 110,
    align: "center",
    ellipsis: true,
    resizable: true
  },
  {
    title: "姓名",
    dataIndex: "displayName",
    width: 120,
    align: "center",
    ellipsis: true,
    resizable: true
  },
  {
    title: "登录账号",
    dataIndex: "userName",
    width: 160,
    align: "center",
    ellipsis: true,
    resizable: true
  },
  {
    title: "角色",
    width: 360,
    align: "center",
    ellipsis: true,
    resizable: true,
    scopedSlots: { customRender: "roleName" }
  },
  {
    title: "职位",
    dataIndex: "jobTitle",
    width: 140,
    align: "center",
    ellipsis: true,
    resizable: true
  },
  {
    title: "手机号",
    align: "center",
    dataIndex: "userTel",
    width: 140,
    ellipsis: true,
    resizable: true
  },
  {
    title: "创建时间",
    align: "center",
    width: 180,
    ellipsis: true,
    resizable: true,
    scopedSlots: { customRender: "insertTime" }
  },
  {
    title: "操作",
    fixed: "right",
    align: "center",
    width: 176,
    className: "erp-table-operation-col",
    key: "operation",
    scopedSlots: { customRender: "operation" }
  }
]
